import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../images/logos/site-logo.svg";
import menuIcon from "../../images/icons/ico-menu.svg";
import closeIcon from "../../images/icons/close.svg";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { get, map } from "lodash";

export default function Header(props) {
  const theme = useTheme();
  const [navOpen, setNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  const navData = useSelector((state) =>
    get(state, "prismic.navigation.data", false),
  );

  const navLinks = get(navData, "navigation", false);

  const renderNav = (navLinks) =>
    map(navLinks, (link, i) => {
      const slug = get(link, "link_url.slug", "");
      const to = slug === "home-page" ? "/" : `/${slug}`;

      return (
        <Link
          onClick={() => setNavOpen(false)}
          key={i}
          to={to}
          className={props.activePage === to ? "active" : undefined}
        >
          {link.link_text[0].text}
        </Link>
      );
    });

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header id="header" className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="wrapper no-max-width">
        <Link
          to="/"
          className={`logo-container ${navOpen ? "hide" : undefined}`}
        >
          <img id="logo" className="logo" src={logo} alt="Brand Logo" />
        </Link>
        {!navOpen && (
          <div
            className={`nav-menu ${navOpen ? "close" : "open"}`}
            onClick={toggleNav}
          >
            <img
              className="mobile-logo"
              src={menuIcon}
              alt="Mobile Brand Logo"
            />
          </div>
        )}

        <nav id="navigation-container" className={navOpen ? "open" : undefined}>
          <div
            className={`nav-menu open-mobile-nav hide-desktop ${
              navOpen ? "close" : "open"
            }`}
            onClick={toggleNav}
          >
            <img src={closeIcon} alt="Close Menu Button" />
          </div>
          <Link className="hide-desktop" to="/">
            <img
              className="mobile-logo open-drawer"
              src={logo}
              alt="Mobile Brand Logo"
            />
          </Link>
          {renderNav(navLinks)}
        </nav>
      </div>
    </header>
  );
}
